// A RÉGI CÍMEK → az EGYESÍTETT `/services` lap search-paramjai.
//
// MIÉRT PURE FÜGGVÉNY, és miért itt: a két régi route (`/service-assignments`, `/service-catalog`) csak
// átirányít, a képzés viszont ÜZLETI TARTALOM — melyik régi kulcs melyik fül melyik szűrőjére fordul. Egy
// `beforeLoad`-ba írva nem tesztelhető, két route-fájlban pedig kétszer élne.
//
// A LINKELT NÉZET IS MEGMARAD, nem csak a lap: a régi, prefix NÉLKÜLI kulcsok (`q`, `status`, `sort`, …) a
// `/services` lapon ütköznének (két lista egy címen), ezért ott mindegyik prefixes (`asg_` / `cat_`).
// A `undefined` értékek KIMARADNAK: egy `?asg_q=undefined` szemét-paramot adna a tiszta linkbe.

/** A hozzárendelés-lista régi search-paramjai (a `/service-assignments` route szerződése volt). */
export interface LegacyAssignmentsSearch {
  edit?: string | undefined;
  clientId?: string | undefined;
  highlight?: string | undefined;
  q?: string | undefined;
  account?: string | undefined;
  scope?: string | undefined;
  type?: string | undefined;
  status?: string | undefined;
  frequency?: string | undefined;
  agreement?: string | undefined;
  pricing?: string | undefined;
  sort?: string | undefined;
  order?: string | undefined;
}

/** A katalógus régi search-paramjai (a `/service-catalog` route szerződése volt). */
export interface LegacyCatalogSearch {
  edit?: string | undefined;
  q?: string | undefined;
  category?: string | undefined;
  status?: string | undefined;
  sort?: string | undefined;
  order?: string | undefined;
}

/** `{ kulcs: érték }` párokból kihagyja az `undefined`-eket (tiszta link). */
function defined(pairs: Record<string, string | undefined>): Record<string, string> {
  return Object.fromEntries(Object.entries(pairs).filter(([, v]) => v !== undefined)) as Record<
    string,
    string
  >;
}

/** `/service-assignments?…` → `/services?tab=assignments&asg_…` */
export function assignmentsRedirectSearch(
  s: LegacyAssignmentsSearch,
): Record<string, string> & { tab: string } {
  return {
    tab: 'assignments',
    ...defined({
      asg_edit: s.edit,
      asg_client: s.clientId,
      asg_highlight: s.highlight,
      asg_q: s.q,
      asg_account: s.account,
      asg_scope: s.scope,
      asg_type: s.type,
      asg_status: s.status,
      asg_frequency: s.frequency,
      asg_agreement: s.agreement,
      asg_pricing: s.pricing,
      asg_sort: s.sort,
      asg_order: s.order,
    }),
  };
}

/** `/service-catalog?…` → `/services?tab=catalog&cat_…` */
export function catalogRedirectSearch(
  s: LegacyCatalogSearch,
): Record<string, string> & { tab: string } {
  return {
    tab: 'catalog',
    ...defined({
      cat_edit: s.edit,
      cat_q: s.q,
      cat_category: s.category,
      cat_status: s.status,
      cat_sort: s.sort,
      cat_order: s.order,
    }),
  };
}
